import gql from 'graphql-tag';

export const getContactListeningData = gql`
  query GetContactListeningData(
    $userID: String!
    $contactStartDate: String!
    $contactEndDate: String!
    $contactId: String!
    $subject: String!
    $queryType: ContactListeningQueryType
    $enableNewAuthFlow: Boolean
  ) {
    getContactListeningData(
      userID: $userID
      contactStartDate: $contactStartDate
      contactEndDate: $contactEndDate
      contactId: $contactId
      subject: $subject
      queryType: $queryType
      enableNewAuthFlow: $enableNewAuthFlow
    ) {
      contact {
        owner {
          agentId
          agentLogin
        }
        medium {
          type
          connectPhoneRecordList {
            presignedUrl
            agent {
              agentId
              agentLogin
            }
            callRecordingPart {
              base64
              nextPart
            }
            connectContactId
          }
          emailSubjectRedacted
          emailBodyRedacted
        }
        dartEscalationContactList {
          owner {
            agentId
            agentLogin
          }
          medium {
            type
            connectPhoneRecordList {
              presignedUrl
              agent {
                agentId
                agentLogin
              }
              callRecordingPart {
                base64
                nextPart
              }
              connectContactId
            }
            emailSubjectRedacted
            emailBodyRedacted
          }
        }
        contactTimeline {
          contactTimelineEvents {
            agent {
              agentId
              agentLogin
              agentOwner
            }
            message
            date
            eventType
            translatedMessage {
              stringId
              values
            }
          }
        }
      }
      errors {
        extensions {
          classification
          code
          exception {
            stacktrace
          }
        }
        message
      }
    }
  }
`;

export const getContactListeningDataWithChat = gql`
  query GetContactListeningData(
    $userID: String!
    $contactStartDate: String!
    $contactEndDate: String!
    $contactId: String!
    $subject: String!
    $queryType: ContactListeningQueryType
    $enableNewAuthFlow: Boolean
  ) {
    getContactListeningData(
      userID: $userID
      contactStartDate: $contactStartDate
      contactEndDate: $contactEndDate
      contactId: $contactId
      subject: $subject
      queryType: $queryType
      enableNewAuthFlow: $enableNewAuthFlow
    ) {
      contact {
        owner {
          agentId
          agentLogin
        }
        medium {
          type
          connectPhoneRecordList {
            presignedUrl
            agent {
              agentId
              agentLogin
            }
            callRecordingPart {
              base64
              nextPart
            }
            connectContactId
          }
          chat {
            messages {
              type
              timestamp
              participant {
                __typename
                preferredLanguage
                ... on CustomerChatParticipant {
                  customerName
                }
                ... on CSAChatParticipant {
                  name
                }
                ... on BotChatParticipant {
                  name
                }
              }
              chatText {
                text
                language
              }
              translationList {
                text
                language
              }
              stateChangeType
              disconnectReason
            }
          }
          emailSubjectRedacted
          emailBodyRedacted
        }
        dartEscalationContactList {
          owner {
            agentId
            agentLogin
          }
          medium {
            type
            connectPhoneRecordList {
              presignedUrl
              agent {
                agentId
                agentLogin
              }
              callRecordingPart {
                base64
                nextPart
              }
              connectContactId
            }
            chat {
              messages {
                type
                timestamp
                participant {
                  __typename
                  preferredLanguage
                  ... on CustomerChatParticipant {
                    customerName
                  }
                  ... on CSAChatParticipant {
                    name
                  }
                  ... on BotChatParticipant {
                    name
                  }
                }
                chatText {
                  text
                  language
                }
                translationList {
                  text
                  language
                }
                stateChangeType
                disconnectReason
              }
            }
            emailSubjectRedacted
            emailBodyRedacted
          }
        }
        contactTimeline {
          contactTimelineEvents {
            agent {
              agentId
              agentLogin
              agentOwner
            }
            message
            date
            eventType
            translatedMessage {
              stringId
              values
            }
          }
        }
      }
      errors {
        extensions {
          classification
          code
          exception {
            stacktrace
          }
        }
        message
      }
    }
  }
`;
